var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0_250_643)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_250_643",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_250_643",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_250_643",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAAXNSR0IArs4c6QAABJ5JREFUeF7tnd1V3DAQha1OQifQSagkUAnbSegk24my4pgTHgLMlT36GX17Dm9jjebezyN57cVp47O0Amnp6il+A4DFIQAAAFhcgcXLpwMAwOIKLF4+HQAAFldg8fLpAABwjgI55x/btr3/nTMoo3ymwGtK6XqGPIc6wG76y7Zt92dMhjEkBQoA5e85pfQqHfkhuBqAnPOv2zhPtYk57jQFCgSXlNJzzYhVAOScf3PW18jtesw1pXSnZpAB4MxXJW4a/6R2AgmAnHNZ68vZz2dMBcpy8KjsCVQAyobv55i1M6tdgXKF8GBVQwXgz36pZx2fuPYKSHsBFYDcvh4yVihwZ/2ewAxAzrm0/rIEfPUp16PV16QVha54SNmHffe9y4N1H3A2APIudEUHj9RsvAorG8GLJQ8AWFQaKAYABjKjx1QAoIfqA+UEgIHM6DEVAOih+kA5AWAgM3pMBQB6qD5QTgAYyIweUwGAHqoPlBMABjKjx1QAoIfqA+UMB0DOudxiXvajPsYVEYClbzHfHuEy348pZwkABOsVAJAzHUCAmg4giDVDKB2ADsAeYIYz1WuOdAA6AB3A6+yaYdzlO8AMJo00x3BXASOJO8NcAGAGlxznCACO4s4wNADM4JLjHAHAUdwZhgaAGVxynCMAOIo7w9DhALgVxN1AgTwAEMSaIXT5bwLpADwRxBIgtCqWAEGsGUJZAtgEcjt4hjPVa450ADrA8h2AH4YI7SXcJlCondCIPwzBVU0BOoCmV7hoAAhnqVYQAGh6hYsGgHCWagUBgKZXuOhwAOxvHhveKOu/X/cuJCIAU9wNVL+y9QIBALyU/WZcALC9MEJ+X8AsD4QAAABIN228GhVLgJeyLAFfK2B8ZxBLgDOgdABngT8bnj0AewD2AIbXxtUsAVO8ilZ5G6dnkwq3BHiKFXFsAIjoqlATAAhiRQwFgIiuCjUBgCBWxFAAiOiqUBMACGJFDAWAiK4KNQGAIFbEUACI6KpQEwAIYkUMBYCIrgo1TQ1AzvnecENJkGPJ0B+Gqh9TShdD3Ga+xXn0gZDd/Cnu/FmEGzzmzvoYexMA9mf/l/4/AC2BUR5ecQcA81ta/5brklJ6tGZ1BWA3/2XbtrL28/FX4Kq+itYNAMz3d/s/GR5SSq9KZk8AyoaPM19x41iseef/MY0LADlnzD9mpnL0ddu2Yr505r8nOB2A/aznzFcs1GOL6W/X+bcd/7N++L8jzgZAnUtV21KTEP+5Aj0BwPwByOwFAOYPYP7bEmKdh/GrYMtwmG9RqVFMawAwv5Gx1jQtAcB8qysN41oBgPkNTVVStQAA8xVHGsd6A4D5jQ1V03kCgPmqGx3ivQDA/A5m1qT0AADza5zodMzZAGB+JyNr054JAObXutDxuLMAwPyOJh5JfQYAmH/Egc7HHgUA8zsbeDT9EQAw/6j6AxxfCwDmD2DeGVOoAQDzz1B+kDFUAMpDiKYfHQ5SH9P4RgEzACgZUwEAiOmruSoAMEsVMxAAYvpqrgoAzFLFDASAmL6aqwIAs1QxAwEgpq/mqgDALFXMQACI6au5KgAwSxUz8C8OPQW9q/dLiAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.380710aad58b5516c42cda9a6c6a6aef.svg";
export { ForwardRef as ReactComponent };